"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_SKU = exports.PRODUCT_SKU_PREFIX = void 0;
var PRODUCT_SKU_PREFIX;
(function (PRODUCT_SKU_PREFIX) {
    PRODUCT_SKU_PREFIX["LICENCIA"] = "ADD-LIC";
    PRODUCT_SKU_PREFIX["HARMON_HALL"] = "ADD-LIC-HH";
    PRODUCT_SKU_PREFIX["CREDITOS_ASESORIA"] = "ADD-CRA";
    PRODUCT_SKU_PREFIX["MEMBRESIA_TALISIS"] = "STA-MEM";
})(PRODUCT_SKU_PREFIX = exports.PRODUCT_SKU_PREFIX || (exports.PRODUCT_SKU_PREFIX = {}));
var PRODUCT_SKU;
(function (PRODUCT_SKU) {
    PRODUCT_SKU["MEMBRESIA_LITE_1M"] = "STA-MEM-LIT-1M";
    PRODUCT_SKU["MEMBRESIA_LITE_3M"] = "STA-MEM-LIT-3M";
    PRODUCT_SKU["MEMBRESIA_LITE_6M"] = "STA-MEM-LIT-6M";
    PRODUCT_SKU["MEMBRESIA_LITE_12M"] = "STA-MEM-LIT-12M";
    PRODUCT_SKU["MEMBRESIA_PROFESSIONAL_1M"] = "STA-MEM-PRO-1M";
    PRODUCT_SKU["MEMBRESIA_PROFESSIONAL_3M"] = "STA-MEM-PRO-3M";
    PRODUCT_SKU["MEMBRESIA_PROFESSIONAL_6M"] = "STA-MEM-PRO-6M";
    PRODUCT_SKU["MEMBRESIA_PROFESSIONAL_12M"] = "STA-MEM-PRO-12M";
    PRODUCT_SKU["MEMBRESIA_PREMIUM_1M"] = "STA-MEM-PRE-1M";
    PRODUCT_SKU["MEMBRESIA_PREMIUM_3M"] = "STA-MEM-PRE-3M";
    PRODUCT_SKU["MEMBRESIA_PREMIUM_6M"] = "STA-MEM-PRE-6M";
    PRODUCT_SKU["MEMBRESIA_PREMIUM_12M"] = "STA-MEM-PRE-12M";
    PRODUCT_SKU["LICENCIA_LINKEDIN_LEARNING"] = "ADD-LIC-LKD";
    PRODUCT_SKU["LICENCIA_CREHANA"] = "ADD-LIC-CRH";
    PRODUCT_SKU["LICENCIA_COURSERA"] = "ADD-LIC-COU";
    PRODUCT_SKU["LICENCIA_SYMPLICITY"] = "ADD-LIC-SYM";
    PRODUCT_SKU["CREDITOS_ASESORIA_2"] = "ADD-CRA-LM2";
    PRODUCT_SKU["CREDITOS_ASESORIA_ILIMITADOS"] = "ADD-CRA-ULM";
    PRODUCT_SKU["MEMBRESIA_HH_STANDARD_3M"] = "ADD-LIC-HH-STD-3M";
    PRODUCT_SKU["MEMBRESIA_HH_STANDARD_6M"] = "ADD-LIC-HH-STD-6M";
    PRODUCT_SKU["MEMBRESIA_HH_STANDARD_12M"] = "ADD-LIC-HH-STD-12M";
    PRODUCT_SKU["MEMBRESIA_HH_PLUS_3M"] = "ADD-LIC-HH-PLU-3M";
    PRODUCT_SKU["MEMBRESIA_HH_PLUS_6M"] = "ADD-LIC-HH-PLU-6M";
    PRODUCT_SKU["MEMBRESIA_HH_PLUS_12M"] = "ADD-LIC-HH-PLU-12M";
    PRODUCT_SKU["MEMBRESIA_HH_ELITE_3M"] = "ADD-LIC-HH-ELI-3M";
    PRODUCT_SKU["MEMBRESIA_HH_ELITE_6M"] = "ADD-LIC-HH-ELI-6M";
    PRODUCT_SKU["MEMBRESIA_HH_ELITE_12M"] = "ADD-LIC-HH-ELI-12M";
})(PRODUCT_SKU = exports.PRODUCT_SKU || (exports.PRODUCT_SKU = {}));
;
